import InvoicesForSubscriptionDatagrid from 'src/components/DatagridEntity/InvoicesForSubscriptionDatagrid';

const InvoicesSubscriptionPage = () => (<InvoicesForSubscriptionDatagrid />);
export default InvoicesSubscriptionPage;
